import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[appRestrictTo]'
})
export class RestrictToDirective {
  @Input() appRestrictTo: string;

  constructor(el: ElementRef) {
    el.nativeElement.addEventListener('keydown', (event) => {
      const exclude = /Backspace|Enter|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|ArrowLeft|Left|ArrowRight|Right/;
      const regex = RegExp(this.appRestrictTo);
      if (!regex.test(event.key) && !exclude.test(event.key)) {
        event.preventDefault();
      }
    });
  }
}
